import { TagGridRow, TagFilters } from '../types';

export function filterTagsGridRows(
  rows: TagGridRow[],
  { filters, searchTextFieldValue }: { filters: TagFilters; searchTextFieldValue: string | null }
): TagGridRow[] {
  let filtered = [...rows];

  // Search filter - only apply if search text is 3+ characters
  if (searchTextFieldValue && searchTextFieldValue.trim().length >= 3) {
    const searchLower = searchTextFieldValue.toLowerCase().trim();
    filtered = filtered.filter(
      (row) =>
        (row.display && row.display.toLowerCase().includes(searchLower)) ||
        (row.code && row.code.toLowerCase().includes(searchLower))
    );
  }

  // Code System filter
  if (filters.codeSystem && Array.isArray(filters.codeSystem) && filters.codeSystem.length > 0) {
    filtered = filtered.filter((row) =>
      filters.codeSystem!.includes(row.codeSystem)
    );
  }

  // Resources filter
  if (filters.resources && Array.isArray(filters.resources) && filters.resources.length > 0) {
    filtered = filtered.filter((row) =>
      filters.resources!.some((resource) => row.resources && row.resources.includes(resource))
    );
  }

  return filtered;
}

